const translates = {
	'en':{
		buttonTitle:'Logout',
	},
	'ru':{
		buttonTitle:'Выйти',
	}
};
export default translates;